const TOKEN_KEY = process.env.VUE_APP_TOKEN_KEY;
const REFRESH_TOKEN_KEY = process.env.VUE_APP_REFRESHTOKEN_KEY;
const USER_KEY = process.env.VUE_APP_USER_KEY;

const TokenService = {
    getToken() {
        return localStorage.getItem(TOKEN_KEY);
    },

    saveToken(accessToken) {
        localStorage.setItem(TOKEN_KEY, accessToken);
    },
    removeToken() {
        localStorage.removeItem(TOKEN_KEY);
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },

    saveRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    },

    removeRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    },

    saveUser(username) {
        localStorage.setItem(USER_KEY, username);
    },

    getUser() {
        return localStorage.getItem(USER_KEY);
    },

    removeUser() {
        localStorage.removeItem(USER_KEY);
    }

};

export { TokenService }